import { MANUFACTURER_VERIFIED, type ManufacturerVerifiedEntry } from '@/data/manufacturerVerified.generated';
import { generateBrandSlug } from '@/lib/brandSlug';

export type { ManufacturerVerifiedEntry };

/**
 * The manufacturer-verified state of one catalog model, or null.
 *
 * Backed by the generated snapshot of applied /verify panel verdicts;
 * the export script guarantees every entry still matches the catalog
 * values the manufacturer actually reviewed (see the generated file's
 * header), so callers can render the badge without re-checking.
 */
export function getManufacturerVerified(
  manufacturer: string,
  model: string,
): ManufacturerVerifiedEntry | null {
  return MANUFACTURER_VERIFIED[`${generateBrandSlug(manufacturer)}|${model}`] ?? null;
}
